/**
 * Generates a DOM-safe id to be used based on a given option.
 */
function optionToId(baseId, value) {
  const baseOptionId = value && typeof value === "object" ? value.id : value;
  return stripInvalidChars(`id-${baseId}-${String(baseOptionId)?.toLowerCase()}`);
}
function stripInvalidChars(str) {
  return str.replaceAll("&", "_og").replaceAll("~", "_tilde").replaceAll("!", "_exclamation").replaceAll("@", "_at").replaceAll("$", "_dollar").replaceAll("%", "_procent").replaceAll("^", "_hat").replaceAll("#", "_hashtag").replaceAll("*", "_stjerne").replaceAll("(", "_sPar").replaceAll(")", "_ePar").replaceAll("+", "_plus").replaceAll("=", "_lig").replaceAll(",", "_komma").replaceAll("'", "_apo").replaceAll(";", "_semi").replaceAll(":", "_kolon").replaceAll('"', "_quote").replaceAll("?", "_question").replaceAll(">", "_gt").replaceAll("<", "_lt").replaceAll("[", "_sBracket").replaceAll("]", "_eBracket").replaceAll("{", "_sCurly").replaceAll("}", "_eCurly").replaceAll("/", "_slash").replaceAll("\\", "_bSlash").replaceAll("|", "_pipe").replaceAll(".", "_dot").replaceAll(/\s/g, "_");
}

export { optionToId };
//# sourceMappingURL=option-to-id.js.map
